import { useQuery } from "@tanstack/react-query";
import { getClientsById, getClientDetails, getTaskDetailsById, getClientOnboardingProgress } from "../components/api/client-onboarding";
import { useSnackbar } from "../components/AppComponents/SnackBarProvider";
import { SEVERITY } from "../utils/messages";
import { api } from "../components/api";
import { useMutation } from "@tanstack/react-query";

export const useGetClientsById = (id, query) => {
    const { updateSnackbar } = useSnackbar();
    return useQuery({
        queryKey: ["client", id, query],
        queryFn: () => getClientsById(id, query),
        enabled: !!id,
        keepPreviousData: true,
        select: (data) => data?.data,
        onError: (error) => {
            console.error("Error fetching client details:", error);
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
        }
    });
};

export const useOnboardClient = (responseHandler) => {
    const {updateSnackbar} = useSnackbar();
    return useMutation({
        mutationKey: ["onboard-client"],
        mutationFn: (payload) => api.client.onboardClient(payload),
        onSuccess: (data) => {
            responseHandler?.();
          
        },
        onError: (error) => {
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
            console.error("Error:",error);
        },
    });
}

export const useGetClientDetails = (params) => {
    const {updateSnackbar} = useSnackbar();
    return useQuery({
        queryKey: ["client-details", params],
        queryFn: () => getClientDetails(params),
        enabled: !!params,
        onError: (error) => {
            console.error("Error fetching client details",error);
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
            console.error("Error:",error)
        }
    })
}

export const useGetClientOnboardingProgress = (clientId) => {
    const { updateSnackbar } = useSnackbar();
    return useQuery({
        queryKey: ["client-onboarding-progress", clientId],
        queryFn: () => getClientOnboardingProgress(clientId),
        enabled: !!clientId,
        keepPreviousData: true,
        select: (data) => data?.data,
        onError: (error) => {
            console.error("Error fetching client onboarding progress:", error);
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
        }
    });
};

export const useAddTaskDetails = () => {
    const {updateSnackbar} = useSnackbar();
    return useMutation({
        mutationKey: ["add-task-details"],
        mutationFn: (payload) => api.client.addTaskDetails(payload),
        onSuccess: (data) => {
            updateSnackbar({
                severity: SEVERITY.success,
                message: data?.message
            });
        },
        onError: (error) => {
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
            console.error("Error:",error)
        }
    });
}

export const useGetTaskDetailsById = (id) => {
    const {updateSnackbar} = useSnackbar();
    return useQuery({
        queryKey: ["task-details", id],
        queryFn: () => getTaskDetailsById(id),
        enabled: !!id,
        onError: (error) => {
            console.error("Error fetching task details",error);
        }
    })
}

export const useDeleteClientById = () => {
    const {updateSnackbar} = useSnackbar();
    return useMutation({
        mutationKey: ["delete-client-by-id"],
        mutationFn: (payload) => api.client.deleteClientById(payload),
        onSuccess: (data) => {
            updateSnackbar({
                severity: SEVERITY.success,
                message: data?.message
            });
        },
        onError: (error) => {
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
        }
    })
}

export const useDeleteTaskDocumentsById = () => {
    const {updateSnackbar} = useSnackbar();
    return useMutation({
        mutationKey: ["delete-task-documents-by-id"],
        mutationFn: (payload) => api.client.deleteTaskDocumentsById(payload),
        onSuccess: (data) => {
            updateSnackbar({
                severity: SEVERITY.success,
                message: data?.message
            });
        },
        onError: (error) => {
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
        }
    })
}

export const useCompleteOnboarding = () => {
    const {updateSnackbar} = useSnackbar();
    return useMutation({
        mutationKey: ["complete-onboarding"],
        mutationFn: (payload) => api.client.completeOnboarding(payload),
        onSuccess: (data) => {
         
        },
        onError: (error) => {
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message
            });
        }
    })
}